document.addEventListener("DOMContentLoaded", () => {
    const sectionId = window.__alphaSectionId;
    if (!sectionId) return;

    const slider = document.getElementById(`alpha-slider-${sectionId}`);
    if (!slider) return;

    const viewport = slider.querySelector(".alpha-slider__viewport");
    const track = slider.querySelector(".alpha-slider__track");
    const slides = Array.from(slider.querySelectorAll(".alpha-slide"));
    const btnPrev = slider.querySelector(".alpha-slider__nav--prev");
    const btnNext = slider.querySelector(".alpha-slider__nav--next");
    const dotsWrapper = slider.querySelector(".alpha-heroslider__dots");

    if (!viewport || !track || slides.length === 0) return;

    let current = 0;
    let autoplay = viewport.dataset.autoplay === "true";
    let interval = parseInt(viewport.dataset.interval) || 5000;
    let pauseOnHover = viewport.dataset.pauseOnHover === "true";
    let autoplayTimer = null;

    /* -----------------------------------
       Set Slide Position
    ----------------------------------- */
    function updatePosition() {
        track.style.transform = `translateX(-${current * 100}%)`;

        const dots = dotsWrapper ? dotsWrapper.querySelectorAll(".alpha-dot") : [];
        dots.forEach((dot, i) => {
            dot.classList.toggle("is-active", i === current);
        });
    }

    /* -----------------------------------
       Navigation Controls
    ----------------------------------- */
    function nextSlide() {
        current = (current + 1) % slides.length;
        updatePosition();
    }

    function prevSlide() {
        current = (current - 1 + slides.length) % slides.length;
        updatePosition();
    }

    if (btnNext) btnNext.addEventListener("click", nextSlide);
    if (btnPrev) btnPrev.addEventListener("click", prevSlide);

    /* -----------------------------------
       Pagination Dots
    ----------------------------------- */
    if (dotsWrapper) {
        dotsWrapper.innerHTML = "";

        slides.forEach((_, index) => {
            const dot = document.createElement("button");
            dot.className = "alpha-dot";
            if (index === 0) dot.classList.add("is-active");

            dot.addEventListener("click", () => {
                current = index;
                updatePosition();
            });

            dotsWrapper.appendChild(dot);
        });
    }

    /* -----------------------------------
       Autoplay
    ----------------------------------- */
    function startAutoplay() {
        if (!autoplay) return;
        stopAutoplay();
        autoplayTimer = setInterval(nextSlide, interval);
    }

    function stopAutoplay() {
        if (autoplayTimer) clearInterval(autoplayTimer);
    }

    if (autoplay) startAutoplay();

    /* Pause on Hover */
    if (pauseOnHover) {
        slider.addEventListener("mouseenter", stopAutoplay);
        slider.addEventListener("mouseleave", startAutoplay);
    }

    /* Ensure correct initial state */
    updatePosition();
});
